<template>
    <div>
        <div v-if="$loadingRouteData"
             class="container -producer">
            <loader></loader>
        </div>

        <div v-if="!$loadingRouteData"
             class="container -producer">
            <ol class="breadcrumb">
                <li><a v-link="{name: 'home'}">Accueil</a></li>
                <li>Producteurs</li>
            </ol>

            <div class="heading">
                <h1>
                    Producteurs

                    <button class="btn btn-primary btn-sm -add-producer"
                            @click.prevent="addProducer">
                        <i class="glyphicon glyphicon-plus"></i>
                        Ajouter un producteur
                    </button>
                </h1>
            </div>

            <div>
                <producer-row :producer="p"
                              v-for="p of producers"></producer-row>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import Loader from '../components/Loader';
    import ProducerRow from '../components/producer/ProducerRow';
    import {listAll, emptyProducer} from '../api/producers';
    import router from '../router';

    export default {
        components: {
            Loader,
            ProducerRow
        },
        data() {
            return {
                producers: []
            };
        },
        route: {
            data: async function () {
                try {
                    return {
                        producers: await listAll()
                    };
                } catch (e) {
                    router.replace({name: 'not-found'});
                }
            }
        },
        methods: {
            addProducer() {
                this.producers.push(emptyProducer());
            }
        }
    };
</script>



// WEBPACK FOOTER //
// Producers.vue?534a3250